import { requestWrapper } from '@/utils/axiosInstance';

export default {
  async create(feature) {
    return await requestWrapper(null, 'POST', '/requirement_characteristics', null, feature);
  },
  async get(id, query) {
    return await requestWrapper(null, 'GET', `/requirement_characteristics/${id}`, query);
  },
  async update(feature) {
    return await requestWrapper(null, 'PUT', `/requirement_characteristics/${feature.id}`, null, feature);
  },
  async remove(id) {
    return await requestWrapper(null, 'DELETE', `/requirement_characteristics/${id}`);
  },
};
